<header class="page-header xs--stack">
  <div *ngIf="hasBackButton" class="page-header__back-link container">
    <p class="margin--none">
      <span class="icon icon-arrow-left icon--xs"></span>
      <a class="link link-primary" (click)="onBackLinkClick()">
        <strong>Back</strong>
      </a>
    </p>
  </div>
  <h1 class="text--center"><ng-content></ng-content></h1>
  <p class="subtitle" select="[subtitle]">
    <ng-content select="[subtitle]"></ng-content>
  </p>
</header>
